import { render, staticRenderFns } from "./tinymce.vue?vue&type=template&id=2c6743d1&scoped=true&"
import script from "./tinymce.vue?vue&type=script&lang=js&"
export * from "./tinymce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6743d1",
  null
  
)

export default component.exports